<template>
  <v-footer class="footer">
    <div class="footer__content pa-3 mb-10 pb-10">
      <p class="mb-5 font--m-4"><strong>고객센터로 무엇이든 물어보세요</strong></p>
      <p>
        <a style="text-decoration: none" href="tel:1811-2708" id="btn__hsd4gvrtJkyvFSUOJg37Uw">
          <v-icon small color="white" class="mr-6">mdi-phone-plus-outline</v-icon></a
        >
        <a
          style="text-decoration: underline white; color: white"
          href="tel:1811-2708"
          id="btn__57AMNyeLE2ToI+L91J5zQ"
          >1811-2708</a
        >
      </p>
      <p>
        <a
          style="text-decoration: none"
          href="mailto:operation@buy-now.kr"
          id="btn__h3du4js3nkKo0WLUtDs45Q"
          ><v-icon small color="white" class="mr-6">mdi-email-outline</v-icon></a
        >
        <a
          style="text-decoration: underline white; color: white"
          href="mailto:operation@buy-now.kr"
          id="btn__rUdmC61bkaGUgl1uZeBtA"
          >operation@buy-now.kr</a
        >
      </p>
    </div>
  </v-footer>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('terms', ['termses']),
    ...mapGetters('contract', ['isServiceAvailable']),
  },
  methods: {
    ...mapActions('terms', ['getTerms']),
  },
}
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: center;

  background-color: rgba(71, 74, 85, 0.5) !important;

  padding: 16px 12px 0px;
}

.footer__content {
  // max-width: $standard-max-width;
  max-width: 500px;
  width: 100%;

  p {
    color: #ffffff;
    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }
  strong {
    color: #ffffff;
  }
}
</style>
